export function moveItemToIndex<T>(items: readonly T[], currentIndex: number, destinationIndex: number): T[] {
  const newItems = [...items];

  const [itemToMove] = newItems.splice(currentIndex, 1);

  newItems.splice(destinationIndex, 0, itemToMove);

  return newItems;
}
